import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import { useCurrentAccountId } from '@zapier/design-system-revenue/src/hooks';
import { invoices as InvoicesQueryData } from './types/invoices';

export const invoicesQuery = gql`
  query invoices($accountId: Int!) {
    account(id: $accountId) {
      id
      invoices {
        id
        createdAt
        hasPendingPayment
      }
    }
  }
`;

export const usePendingPayment = () => {
  const { accountId } = useCurrentAccountId();
  const { data, loading } = useQuery<InvoicesQueryData>(invoicesQuery, {
    skip: !accountId,
    variables: { accountId },
  });

  const pendingInvoice = data?.account?.invoices?.find(
    invoice => invoice.hasPendingPayment
  );

  return {
    pendingInvoice,
    isLoading: loading,
  };
};
